import React from "react";
import { Box } from "@mui/material";
import { ContentArea } from "./content.style";

interface ExtRouteComponentProps {
  children?: React.ReactNode;
}

export const ContentComponent = (props: ExtRouteComponentProps) => {
  return (
    <ContentArea>
      <Box sx={{ mb: 1.25 }}>{props.children}</Box>
    </ContentArea>
  );
};
